
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppDocumentPageSettingsBackgroundImage from "@/components/document-settings/PageSettingsBackgroundImage.vue";
import AppDocumentPageSettingsDefault from "@/components/document-settings/PageSettingsDefault.vue";
import AppDocumentPageSettingsFont from "@/components/document-settings/PageSettingsFont.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { TextStyledProperty } from "@/utils/documents/text-styled-property";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			config: DossierConfigService.getDefaultReportConfig(),
			toEditStyle: null as null | TextStyledProperty
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings", value: this.$ct("general")
				},
				{
					value: this.$ct("reports")
				}
			] as IBreadCrumb[];
		},
	},
	methods: {
		async save() {
			try {
				await DossierConfigService.saveDefaultReportConfig(this.config);
				this.$router.push("/settings");
			} catch (err:any) {
				this.$wf.notify(err.message, "danger", 3000, "triangle-exclamationmark");
			}
		},
		editStyle(style: TextStyledProperty) {
			this.toEditStyle = style;
		},
		closeEditStyle(value: boolean) {
			if (value) return;
			this.toEditStyle = null;
		}
	},
	components: {
		AppStyleEditor,
		AppDocumentPageSettingsDefault,
		AppDocumentPageSettingsBackgroundImage,
		AppDocumentPageSettingsFont,
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
